import React, { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import Layout from './pages/layout.js';
import Home from './pages/home.js';
import Contact from './pages/contact.js';
import Services from './pages/services.js';
import Team from './pages/team.js';
import Politica from './pages/politica-de-privacidad.js';
import News from './pages/news.js';
import Ffmm from './pages/ffmm.js';
import Churches from './pages/churches.js';
import LawyerProfile from './components/lawyer-profile.js';
import Areas from './pages/areas.js';

function App() {
  const [lawyers, setLawyers] = useState([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/lawyers.txt`)
      .then(response => response.text())
      .then(text => {
        const lines = text.split('\n').filter(line => line.trim() !== '');
        const lawyersData = lines.map(line => {
          const fields = line.split(';');
          if (fields.length !== 7) return null;
          const [id, name, area, profile, image, email, phone] = fields;
          return {
            id: id.trim(),
            name: name.trim(),
            area: area.trim(),
            profile: profile.trim(),
            image: `${process.env.PUBLIC_URL}/img/abg/${image.trim()}`,
            email: email.trim(),
            phone: phone.trim()
          };
        }).filter(lawyer => lawyer !== null);
        setLawyers(lawyersData);
      });
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/areas" element={<Areas />} />
          <Route path="/team" element={<Team />} />
          <Route path="/politica-privacidad" element={<Politica />} />
          <Route path="/actualidad" element={<News />} />
          <Route path="/ffmm" element={<Ffmm />} />
          <Route path="/churches" element={<Churches />} />
          <Route path="/lawyer-profile/:id" element={<LawyerProfile lawyers={lawyers} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
